<template>
    <div class="form-group">
        <label :for="id">{{ label }}</label>
        <select
            :id="id"
            :value="value"
            @change="$emit('change', $event.target.value)"
            :name="name"
            :required="required"
            :disabled="disabled"
        >
            <option :value="'yes'">{{ $translate.text('general.yes') }}</option>
            <option :value="'no'">{{ $translate.text('general.no') }}</option>
        </select>
    </div>
</template>

<script>
export default {
    name: 'YesNoInput',

    props: {
        label: {
            type: String,
            default: '',
        },

        id: {
            type: String,
            required: true,
        },

        value: {
            required: true,
        },

        name: {
            type: String,
        },

        required: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style lang="scss" scoped>
.form-group {
   display: flex;
   align-items: center;

    label {
        color: $black;
        flex: 2;
    }

    select {
        flex: 6;
        height: 42px;
        font-size: 16px;
        border: 0;
        background-color: white;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        cursor: pointer;
        padding: 0px 16px;
    }
}
</style>
